import ResourceApi from 'utils/ResourceApi'

class LocationApi extends ResourceApi {
    url = () => {
        return '/backend/locations'
    }
}

export default new LocationApi()